import React from 'react'
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Stack,
} from '@mui/material'
import { Person as PersonIcon } from '@mui/icons-material'
import { useAuth } from '../contexts/AuthContext'

const ROLE_DISPLAY = {
  system_admin: 'System Admin',
  administrator: 'Administrator',
  researcher: 'Researcher',
  clinical_designer: 'Clinical Designer',
}

function Dashboard() {
  const { adminUser } = useAuth()

  const roleLabel = ROLE_DISPLAY[adminUser?.role] || adminUser?.role || 'User'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      <Paper sx={{ maxWidth: 400, width: '100%', p: 4, textAlign: 'center' }}>
        <Avatar
          sx={{
            width: 64,
            height: 64,
            mx: 'auto',
            mb: 2,
            bgcolor: 'primary.main',
          }}
        >
          <PersonIcon sx={{ fontSize: 32 }} />
        </Avatar>

        <Typography variant="h5" gutterBottom>
          Welcome to ASTA
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          Management Portal
        </Typography>

        {adminUser && (
          <Stack spacing={1} sx={{ mt: 3 }} alignItems="center">
            <Typography variant="subtitle1" fontWeight={500}>
              {adminUser.name || adminUser.email}
            </Typography>

            {adminUser.email && adminUser.name && (
              <Typography variant="body2" color="text.secondary">
                {adminUser.email}
              </Typography>
            )}

            <Typography variant="body2" color="primary.main" fontWeight={500}>
              {roleLabel}
            </Typography>

            {adminUser.cognito_sub && (
              <Typography variant="caption" color="text.disabled" sx={{ mt: 1 }}>
                ID: {adminUser.cognito_sub.slice(0, 8)}...
              </Typography>
            )}
          </Stack>
        )}

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          Use the navigation menu to manage intervention content, patients, and analytics.
        </Typography>
      </Paper>
    </Box>
  )
}

export default Dashboard
